import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import IssuerForm from './IssuerForm';
import IssuerList from './IssuersList';
import { Helmet } from 'react-helmet-async';
import { getAllCompanies } from '../../../services/apiservice';
import { useApiData } from '../../../hooks/useApi';

function ManageIssuersByAdmin() {
  const [tabIndex, setTabIndex] = useState(0);
  const [showMoreDetails, setShowMoreDetails] = useState(false);
  const [companies, setCompanies] = useState([]);
  const { data: fetchedCompanies } = useApiData(() => getAllCompanies().then((res) => res.data), []);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  useEffect(() => {
    if (fetchedCompanies) {
      setCompanies(fetchedCompanies);
    }
  }, [fetchedCompanies]);

  return (
    <Box sx={{ width: '100%', overflowX: 'auto' }}>
      <Helmet>
        <title>Manage Issuers</title>
      </Helmet>
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        textColor="primary"
        indicatorColor="primary"
        sx={{ ml: 4 }}
        TabIndicatorProps={{ sx: { width: 'auto' } }}
      >
        <Tab label="Manage Issuers" sx={{ minWidth: "auto", px: 2 }} />
        <Tab label="Create Issuer" sx={{ minWidth: "auto", px: 2 }} />
      </Tabs>

      {tabIndex === 0 && (
        <Box p={3}>
          <IssuerList />
        </Box>
      )}

      {tabIndex === 1 && (
        <Box p={3}>
          <IssuerForm allCompanies={companies} />
        </Box>
      )}
    </Box>
  );
}

export default ManageIssuersByAdmin;
